import { Modal } from '@mui/material'
import React, { useState } from 'react'
import cssClasses from './GroupNameModal.module.css'
import CustomInput from '../CustomInput'
import Button from '../Button'
import Close from '../../Components/Icons/Close'
import CustomAutoComplete from '../CustomAutoComplete'
export default function GroupNameModal({ open, handleClose, setGroupName, groupName, createGroup, allChildGroups }) {
    const [helperText, setHelperText] = useState('')

    return (
        <Modal open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={
                [
                    {
                        ".MuiBackdrop-root": {
                            background: "rgba(52, 64, 84, 0.7)",
                        },
                    },
                ]}
            disableAutoFocus={true} >
            <div className={cssClasses.modalWrapper}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '1.4rem'
                }}>
                    <p style={{ fontSize: '2.4rem', fontFamily: 'Inter-Regular' }}>Enter Group Name</p>
                    <div onClick={handleClose}>
                        <Close width={"1.6rem"} height={"1.6rem"} />
                    </div>
                </div>
                <div style={{ marginBottom: "2rem" }}>
                    <CustomAutoComplete disable={false} freeSolo={true} list={allChildGroups} OnInputChange={(e) => { setGroupName(e.target.value) }} InitialValue={(e) => { setGroupName(e) }} placeholder={'Enter Group Name'} value={groupName} helperText={helperText} />
                    {/* <CustomInput handleChange={(e) => { setGroupName(e) }} placeholder={'Enter Group Name'} value={groupName} helperText={helperText} /> */}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div>
                        <Button clicked={() => { if (groupName === '') { setHelperText('Please Enter Group Name') } else { createGroup() } }} style={{ borderRadius: "0.4rem", backgroundColor: "#1570EF", color: "#FFFFFF", fontSize: "1.6rem" }} btnName={'Save'} />
                    </div>
                </div>
            </div>
        </Modal >
    )
}
